import Vue from 'vue'
import Router from '@/router';

import {
	LOGIN_SUCCESS,
	LOGIN_FAILED,
	LOGOUT,

	VERIFICATION_SUCCESS,
	VERIFICATION_FAILED,

	FETCH_SUBSCRIPTIONS_SUCCESS,
	FETCH_SUBSCRIPTIONS_FAILED,

	FETCH_PUB_SUBSCRIPTIONS,

	FETCH_QUESTIONS_SUCCESS,
	FETCH_QUESTIONS_FAILED,

	FETCH_PUB_QUESTIONS_SUCCESS,
	FETCH_PUB_QUESTIONS_FAILED,

	SHOW_MODAL,
	HIDE_MODAL,

	SET_QUESTION,

	REGISTER_ACCOUNT_SUCCESS,
	REGISTER_ACCOUNT_FAILURE,

	SET_COMPANY,

	PAY_SUBSCRIPTION_SUCCESS,
	PAY_SUBSCRIPTION_FAILED,

	SHOW_NOTIF,
	CLOSE_NOTIF,
} from '@/store/types';

const state = {
	userDetails: {
		userId: localStorage.getItem('userId'),
		email: localStorage.getItem('email'),
		token: localStorage.getItem('token'),
	},

	isLoggedIn: null,

	company: null,
	companies: [],

	error: null,

	modalVisible: false,
	modalComponent: null,

	questions: [],
	question: '',
	questionTitle: '',
	restrictedQuestions: true,

	registered: false,

	stripeKey: process.env.NODE_ENV === 'production' ? process.env.STRIPE_API_KEY : process.env.STRIPE_API_TEST_KEY,

	notification: {
		show: false,
		type: '',
		message: '',
		duration: 5000,
	}
};

const mutations = {

	[SHOW_NOTIF] (state, notifOptions) {
		state.notification = notifOptions
	},
	[CLOSE_NOTIF] (state) {
		state.notification = {
			show: false,
			type: '',
			message: '',
			duration: 5000,
		}
	},

	[LOGIN_SUCCESS] (state, userDetails) {
		state.userDetails = userDetails
		state.isLoggedIn = true
	},
	[LOGIN_FAILED] (state, error) {
		state.isLoggedIn = false
	},
	[LOGOUT] (state, blankedDetails) {
		state.userDetails = blankedDetails
		state.isLoggedIn = false
		state.registered = false
		state.companies = []
		state.restrictedQuestions = true
	},

	[VERIFICATION_SUCCESS] (state, userDetails) {
		state.userDetails = userDetails
		state.isLoggedIn = true
	},
	[VERIFICATION_FAILED] (state, error) {
		state.isLoggedIn = false
	},

	[FETCH_SUBSCRIPTIONS_SUCCESS] (state, companies) {
		state.companies = companies
	},
	[FETCH_SUBSCRIPTIONS_FAILED] (state, error) {
		state.companies = []
		state.error = error
	},

	[FETCH_PUB_SUBSCRIPTIONS] (state, companies) {
		state.companies = companies
	},

	[FETCH_QUESTIONS_SUCCESS] (state, questions) {
		state.questions = questions.questions
		state.restrictedQuestions = questions.restricted
	},
	[FETCH_QUESTIONS_FAILED] (state, error) {
		state.error = error
	},

	[FETCH_PUB_QUESTIONS_SUCCESS] (state, questions) {
		state.questions = questions.questions
		state.restrictedQuestions = questions.restricted
	},
	[FETCH_PUB_QUESTIONS_FAILED] (state, error) {
		state.error = error
	},

	[SHOW_MODAL] (state, componentName) {
		state.modalVisible = true;
		state.modalComponent = componentName;
	},
	[HIDE_MODAL] (state, error) {
		state.modalVisible = false;
	},

	[SET_QUESTION] (state, question) {
		state.question = question.question.trim();
		state.questionTitle = question.title;
	},

	[REGISTER_ACCOUNT_SUCCESS] (state, userDetails) {
		state.userDetails = userDetails
		state.isLoggedIn = true;
		state.registered = true;
	},
	[REGISTER_ACCOUNT_FAILURE] (state, error) {
		state.registered = false;
		state.error = error;
	},

	[SET_COMPANY] (state, company) {
		state.company = company;
	},

	[PAY_SUBSCRIPTION_SUCCESS] (state, companies) {
		state.companies = companies;
		state.restrictedQuestions = false;
	},
	[PAY_SUBSCRIPTION_FAILED] (state, error) {
		state.error = error;
	},

};

export default {
	state,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js